import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutingService } from '../../services/helper/routing.service';
import { authService } from '../../services/auth.service';
import { utilityService } from '../../services/utility.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: false,
})
export class NavbarComponent implements OnInit, OnDestroy{

  private readonly destroyed$ = new Subject<void>();

  isLoggedin:boolean = false;
  user;
  iarCount:number = 0;
  constructor(
    private router: Router,
    public routing:RoutingService,
    public auth: authService,
    private utility: utilityService
  ){

  }

  ngOnInit(): void {
    this.auth.userDetail$.pipe(takeUntil(this.destroyed$)).subscribe(res => {
      if(res){
        this.user = res;
      }
    })

    this.utility.assessCoinsCount$.pipe(takeUntil(this.destroyed$)).subscribe(res => {
      if(res) {
        this.iarCount = res
      } else {
        this.iarCount = 0
      }
     
    })


  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
